import { Box, Chip, Stack } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import {
  MISSING_DATA_KINDS,
  MISSING_DATA_KIND_COLORS,
  MISSING_DATA_KIND_TRANSLATION_KEYS,
  missingDataKindKey,
  type MissingDataKind,
} from "./pipelineLevel";

type PipelineLevelFilterProps = Readonly<{
  enabledKinds: ReadonlySet<string>;
  onToggle: (kind: MissingDataKind) => void;
  countsByKind: Readonly<Record<string, { fn: number; fp: number }>>;
}>;

export const PipelineLevelFilter = ({
  enabledKinds,
  onToggle,
  countsByKind,
}: PipelineLevelFilterProps) => {
  const { t } = useTenantTranslation();

  return (
    <Stack direction="row" spacing={0.5} flexWrap="wrap">
      {MISSING_DATA_KINDS.map((kind) => {
        const key = missingDataKindKey(kind);
        const { fn, fp } = countsByKind[key] ?? { fn: 0, fp: 0 };
        if (fn === 0 && fp === 0) return null;
        const enabled = enabledKinds.has(key);
        const isFullPipeline = kind === null;
        return (
          <Chip
            key={key || "full"}
            size="small"
            variant={enabled ? "filled" : "outlined"}
            onClick={() => {
              onToggle(kind);
            }}
            label={`${t(MISSING_DATA_KIND_TRANSLATION_KEYS[key] ?? "")} (FN = ${fn}${isFullPipeline ? `, FP = ${fp}` : ""})`}
            icon={
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: MISSING_DATA_KIND_COLORS[key],
                  ml: 0.5,
                }}
              />
            }
          />
        );
      })}
    </Stack>
  );
};
